<template>
    <b-form-group :label="$t('Component(Label):sent-request-email-notification-recipients')">
        <b-form-checkbox
            v-for="email in emails"
            :key="email"
            v-model="selectedEmails"
            :value="email"
            class="mb-1"
        >
            {{ email }}
        </b-form-checkbox>
    </b-form-group>
</template>

<script>
import { BFormCheckbox, BFormGroup } from 'bootstrap-vue'

export default {
    components: {
        BFormCheckbox,
        BFormGroup,
    },
    props: {
        emails: {
            type: Array,
            required: true,
        },
        value: {
            type: Array,
            required: true,
        },
    },
    computed: {
        selectedEmails: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
    },
}
</script>
